import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=db9c092c&scoped=true&"
var script = {}
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=db9c092c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9c092c",
  null
  
)

export default component.exports